const http = require('../lib/httpClient');
const {
  deleteCookie,
  getChannelId,
  getCookie,
  getEcommId,
  setCookie,
} = require('../lib/browserData');
const getZoneId = require('../lib/zoneData');
const getPoliticalId = require('../lib/politicalIdData');
const { COOKIES, SELLER_EXPERIENCE } = require('../constants');
const catalystGetCart = require('./catalystGetCart');
const getPoliticalIdWithLatLong = require('../lib/politicalIdDataWithLatLong');
const constants = require('../constants');

const SessionNotFoundError = {
  code: 'GET_CART_COUNT_ERROR_SESSION_NOT_FOUND',
  message: 'Session not found',
};
const GetCartCountError = {
  code: 'GET_CART_COUNT_ERROR',
  message: 'Failed to get cart count',
};

const endpointPattern = '/s/checkout/v1/carts/{cartId}/count?{query}';

function isResourceNotExistsError({ errors = [] }) {
  if (errors.length > 0 && errors.some(({ code }) => code === 'RESOURCE_NOT_EXISTS')) return true;
  return false;
}

async function getCartCountFromGetCart(tenantId, catalystBaseUrl) {
  const { data: { cartId, totalProductsQuantityCount } = {}, errors } = await catalystGetCart(
    tenantId,
    catalystBaseUrl,
  );

  if (!cartId) {
    deleteCookie(COOKIES.CART_ID.VALUE, tenantId);
    return { cartCount: undefined, errors: [GetCartCountError] };
  }
  setCookie(COOKIES.CART_ID.VALUE, cartId, tenantId, COOKIES.CART_ID.EXPIRY);
  if (!totalProductsQuantityCount) {
    return { cartCount: undefined, errors: errors || [GetCartCountError] };
  }
  return { cartCount: totalProductsQuantityCount, errors };
}

async function catalystGetCartCount(cartId, tenantId, catalystBaseUrl = '', additionalInfo = {}) {
  const sessionId = getCookie(COOKIES.SESSION.VALUE);
  if (!sessionId) return { cartCount: undefined, errors: [SessionNotFoundError] };
  const isMarketPlace = getCookie(COOKIES.SELLER_EXPERIENCE) === SELLER_EXPERIENCE.MARKETPLACE;

  const ecommName = getEcommId(tenantId, additionalInfo);
  const isTottus = ecommName.split('-')[0] === constants.ECOMM_NAME_TOTTUS;
  const {
    politicalId: tottusPoliticalId,
    lat,
    long,
  } = isTottus ? await getPoliticalIdWithLatLong(ecommName, catalystBaseUrl) : {};
  const zoneId = isMarketPlace ? '' : await getZoneId(tenantId, catalystBaseUrl);
  const politicalId = isTottus
    ? tottusPoliticalId
    : await getPoliticalId(tenantId, catalystBaseUrl);
  const latLong = isTottus && lat && long ? `&lat=${lat}&long=${long}` : '';

  const endpoint = endpointPattern
    .replace('{cartId}', cartId)
    .replace(
      '{query}',
      isMarketPlace ? `politicalAreaId=${politicalId}${latLong}` : `zoneId=${zoneId}${latLong}`,
    );
  const result = await http.get(`${catalystBaseUrl}${endpoint}`, {
    headers: {
      Authorization: sessionId,
      'x-channel-id': getChannelId(),
      'x-ecomm-name': ecommName,
    },
  });

  const { responseBody } = result || {};

  if (!responseBody) return { cartCount: undefined, errors: [GetCartCountError] };
  if (isResourceNotExistsError(responseBody)) {
    return getCartCountFromGetCart(tenantId, catalystBaseUrl);
  }

  const { data, data: { cart: { totalProductsQuantityCount } = {} } = {}, errors } = responseBody;

  if (!data || !totalProductsQuantityCount) {
    return { cartCount: undefined, errors: errors || [GetCartCountError] };
  }
  return { cartCount: totalProductsQuantityCount, errors: [] };
}

module.exports = catalystGetCartCount;
